import React, { Component } from "react";
import { connect } from "react-redux";
import { cloud, cherry } from "@vitalsource/vstui/colors";
import styled from "styled-components";
import { Dialog, Button } from "@vitalsource/vstui";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { actions as bridgeActions } from "../../../../redux/bridge";
import { actions as modalActions } from "../../../../redux/modals";
import { t, Translation } from "../../../core/translate";
import Spinner from "../../../components/spinner";
import { Stopwatch } from "@vitalsource/vstui-icons";
//import { LendingRules } from "./lending-rules";
import { TextEllipsis } from "../../../components/text-ellipsis";
import LibraryHelpers from "../../../../stores/library-helpers";

const AssetContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  min-height: 150px;
`;
const AssetImage = styled.span`
  padding-right: 10px;
  img {
    width: 34px;
    height: 46px;
  }
`;
const AssetTitle = styled.div`
  flex: 1 1 0;
  font-size: 1.6rem;
`;
const AssetDuration = styled.div`
  white-space: nowrap;
  svg {
    display: inline-block;
  }
`;
const TimeRemaining = styled.span`
  font-size: 1.6rem;
  font-style: italic;
  font-weight: 400;
  padding-left: 10px;
  text-transform: lowercase;
`;
const AssetsList = styled.ul`
  height: 250px;
  width: 100%;
`;
const AssetListing = styled.li`
  display: flex;
  align-items: center;
  height: 65px;
  border-bottom: 1px solid ${cloud.getShade(4)};
`;
const RightColumn = styled.div`
  align-items: baseline;
  display: flex;
  flex: 1 1 0;
  justify-content: ${props => (props.alignContent ? "flex-end" : "center")};
`;
const ReturnButtonContainer = styled.div`
  padding-left: 10px;
  white-space: nowrap;
`;
const ExtraLargeDialog = styled(Dialog)`
  *[role="dialog"] {
    width: 600px;
  }
`;
const activeParams = {
  sort: "recent",
  active: true,
  limit: 100
};

const getExpiresDuration = asset => {
  let expireDate = "";
  if (asset.expirationDate && asset.expirationDate !== "never") {
    expireDate = asset.expirationDate;
  } else {
    return "";
  }
  const millisecondsPerHour = 1000 * 60 * 60;
  let diff = new Date(expireDate) - new Date();
  let timeInHours = diff / millisecondsPerHour;
  if (timeInHours < 24) {
    return (
      <AssetDuration>
        <Stopwatch color={cherry.getShade(1)} />
        <TimeRemaining>
          <Translation id="library.less-than-day" />
        </TimeRemaining>
      </AssetDuration>
    );
  } else {
    return (
      <AssetDuration>
        <Stopwatch color={cloud.getShade(6)} />
        <TimeRemaining>
          <Translation
            id="library.num-days"
            days={parseInt(timeInHours / 24)}
          />
        </TimeRemaining>
      </AssetDuration>
    );
  }
};

class Credits extends Component {
  componentDidMount() {
    this.props.fetchLists([activeParams]);
  }

  render() {
    const {
      closeModal,
      isAssetsFetching,
      activeAssets,
      showReturnButtonColumn
    } = this.props;

    return (
      <ExtraLargeDialog
        closeButtonLabel={t("base.close", "Close")}
        darkHeader
        onRequestClose={closeModal}
        open
        size="large"
        title={t("footer.borrowed-items-title", "Borrowed Items", {
          used: activeAssets.length
        })}
      >
        <AssetContainer>
          {isAssetsFetching && <Spinner styles={{ paddingTop: 90 }} />}
          {!isAssetsFetching && (
            <AssetsList>
              {activeAssets.map(asset => (
                <AssetListing key={asset.vbid}>
                  <AssetImage>
                    <img alt={asset.title} src={asset.coverImageUrl} />
                  </AssetImage>
                  <AssetTitle>
                    <TextEllipsis
                      toolTipText={asset.title.decodeHTML()}
                      lines={2}
                    >
                      <div>{asset.title.decodeHTML()}</div>
                    </TextEllipsis>
                  </AssetTitle>
                  <RightColumn alignContent={asset.returnable}>
                    {getExpiresDuration(asset)}
                    {showReturnButtonColumn && (
                      <ReturnButtonContainer>
                        {asset.returnable && (
                          <Button
                            naked
                            onClick={() => {
                              this.props.returnBook(asset.vbid);
                              LibraryHelpers.returnBookToast(
                                asset.title,
                                asset.vbid
                              );
                            }}
                          >
                            {t("footer.return", "Return")}
                          </Button>
                        )}
                      </ReturnButtonContainer>
                    )}
                  </RightColumn>
                </AssetListing>
              ))}

              {activeAssets.length === 0 && t("footer.no-borrowed-items")}
              {/* // Hide lending rules for credits-only version
                <LendingRules />
              */}
            </AssetsList>
          )}
        </AssetContainer>
      </ExtraLargeDialog>
    );
  }
}

const mapStateToProps = (state, props) => ({
  isAssetsFetching: bridgeSelectors.isAssetsFetching(state, activeParams),
  activeAssets: bridgeSelectors.getAssets(state, activeParams),
  showReturnButtonColumn: bridgeSelectors.getHasActiveReturnableAsset(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  closeModal: () => dispatch(modalActions.closeModal()),
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists)),
  returnBook: vbid => dispatch(bridgeActions.returnAsset(vbid))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Credits);
